// 峰会议程 6月11日
export const SUMMIT_DAY_1 = {
  title: '6月11日',
  day: 'DAY 1',
  host: '主会场',
  report: '第一报告厅',
  content: [
    {
      time: '08:50-12:15',
      title: '开幕式',
      content: '包含领导巡展、政府领导致辞、专家院士主旨演讲、AtomGit代码协作平台发布、云原生工作委员会成立仪式、签约仪式、项目捐赠仪式、国内外企业重磅嘉宾主题演讲等重要环节',
      speaker: '',
      schedule: '主题日程（拟定）',
      guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        {
          time: '08:50-09:30',
          content: [
            '**领导巡展**',
          ],
        },
        {
          time: '09:30-09:40',
          content: [
            '**领导致辞**',
          ],
        },
        {
          time: '09:40-10:10',
          content: [
            '**主旨报告**',
            '**梅宏**  中国科学院院士',
          ],
        },
        {
          time: '10:10-10:15',
          content: [
            '**北京国际开源社区启航仪式**',
          ],
        },
        {
          time: '10:15-10:25',
          content: [
            '**开源项目捐赠仪式**',
          ],
        },
        {
          time: '10:25-10:40',
          content: [
            '**主题演进：《开放原子 聚善为源》**',
            '**孙文龙**  开放原子开源基金会理事长',
          ],
        },
        {
          time: '10:40-12:00',
          content: [
            '**国内外企业重磅嘉宾主题演讲**',
          ],
        },
        {
          time: '12:00-12:05',
          content: [
            '**群智范式项目及AtomGit代码协作平台发布**',
          ],
        },
        {
          time: '12:05-12:10',
          content: [
            '**云原生工作委员会发起倡议**',
          ],
        },
        {
          time: '12:10-12:15',
          content: [
            '**开源教育委员会发起倡议**',
          ],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/3608af827e2038a5/output.jpg',
      producerCounts: 0,
    },
    {
      time: '14:00-17:30',
      title: '高峰论坛',
      content: '包含政府领导致辞、院士专家主旨报告、开源安全委员会发布仪式、国内外企业重磅嘉宾主题演讲、开源贡献之星授牌仪式、圆桌对话等重要环节',
      // speaker: '延军 | 云杉网络研发云杉网 VP',
      schedule: '主题日程（拟定）',
      guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        {
          time: '14:00-14:15',
          content: [
            '**领导致辞**',
          ],
        },
        {
          time: '14:15-14:45',
          content: [
            '**主旨报告**',
            '**王怀民** 中国科学院院士',
          ],
        },
        {
          time: '14:45-14:55',
          content: [
            '**主旨报告**',
            '**陆首群** 中国开源软件推进联盟名誉主席',
          ],
        },
        {
          time: '14:55-15:00',
          content: [
            '**开放原子开源基金会与中国金融电子化集团合作签约仪式**',
          ],
        },
        {
          time: '15:00-15:05',
          content: [
            '**《北京市软件行业发展报告》发布**',
          ],
        },
        {
          time: '15:05-15:10',
          content: [
            '**开源漏洞信息共享项目发布**',
          ],
        },
        {
          time: '15:10-16:40',
          content: [
            '**国内外企业重磅嘉宾主题演讲**',
          ],
        },
        {
          time: '16:40-17:30',
          content: [
            '**开源论道圆桌**',
          ],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/68e871c86e1ed0f1/output.jpg',
      producerCounts: 0,
    },
    {
      time: '19:00-20:30',
      title: '开发者之夜',
      content: '一场开源界的老友聚会，一场面向开发者的答谢晚宴，一场业内公认的顶尖盛会！',
    },
  ],

  branch: [
    {
      divide: '分会场1',
      day: 'DAY 1',
      report: '会议室AB',
      content: [
        {
          time: '14:00-17:10',
          title: 'OpenCloudOS社区年会',
          content: '云原生技术近年来不断发展，催生出越来越多的新场景。作为企业 IT 系统的底层技术，操作系统所面临的问题也变得复杂。本论坛将汇聚操作系统上下游厂商、用户，共同向业界阐述OpenCloudOS作为未来数字时代创新基础底座的实践与积累。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '14:00-14:20',
              content: [
                '**领导致辞**',
              ],
            },
            {
              time: '14:20-14:30',
              content: [
                '**OpenCloudOS社区理事会增选**',
              ],
            },
            {
              time: '14:30-14:40',
              content: [
                '**社区优秀贡献企业颁奖仪式**',
              ],
            },
            {
              time: '14:40-14:50',
              content: [
                '**社区品牌委员会升级**',
              ],
            },
            {
              time: '14:50-15:10',
              content: [
                '**OpenCloudOS开源共筑未来数字时代创新基础底座**',
                '**王佳**  OpenCloudOS社区TOC成员、腾讯操作系统负责人',
              ],
            },
            {
              time: '15:10-15:30',
              content: [
                '**休息**',
              ],
            },
            {
              time: '15:30-15:50',
              content: [
                '**作业帮如何利用 OpenCloudOS 解决技术难题**',
                '**吕亚霖**  作业帮基础架构、架构研发团队负责人',
              ],
            },
            {
              time: '15:50-16:10',
              content: [
                '**开源社区给操作系统产业带来的机遇与挑战**',
                '**崔黎明**  OpenCloudOS社区副理事长、广东中兴新支点技术有限公司副总经理兼OS操作系统产品总经理',
              ],
            },
            {
              time: '16:10-16:30',
              content: [
                '**OpenCloudOS Edae 发行版本特性解读及实践**',
                '**刘成钢**  OpenCloudOS社区边缘SIG负责人、中讯邮电设计院',
                '**赵健**  腾讯操作系统研发工程师',
              ],
            },
            {
              time: '16:30-16:50',
              content: [
                '**共建国内软硬件开源生态——飞腾在OpenCloudOS开源社区的实践分享**',
                '**帅家坤** OpenCloudOS社区飞腾SIG负责人、飞腾高级工程师',
              ],
            },
            {
              time: '16:50-17:10',
              content: [
                '**基于OpenCloudOS的新一代IaaS底座**',
                '**侯俊** OpenCloudoS社区TOC副主席、海云捷迅云计算产品研发负责人',
              ],
            },
            {
              time: '17:10',
              content: [
                '**合影留念**',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/f90f0b9f99f4dc43/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场2',
      day: 'DAY 1',
      report: '会议室C',
      content: [
        {
          time: '10:00-12:00',
          title: '开源商业化创新发展分论坛',
          content: '软通动力积极构建开源生态，推动产业上下游参与开源共建，推动开源人才生态发展。本论分享软通动力及其生态伙伴以大胆创新、开放意识，在产业端、人才端进行的实践分享，探讨在开源精神引领下，进行多方合作、协同创新的模式与路径。',
          speaker: '',
          schedule: '主题日程（拟定）',
          scheduleList: [
            {
              time: '10:00-10:05',
              content: [
                '**开场**',
              ],
            },
            {
              time: '10:05-10:20',
              content: [
                '**领导致辞**',
              ],
            },
            {
              time: '10:20-10:40',
              content: [
                '**《开放与共享——开源精神下的产教融合共赢新模式》**',
                '**谭帅**  软通教育首席运营官',
              ],
            },
            {
              time: '10:40-10:50',
              content: [
                '**【签约仪式】软通教育全国合作伙伴签约**',
              ],
            },
            {
              time: '10:50-11:05',
              content: [
                '**《安全设计，助力城市OpenHaromony化建设》**',
                '**邵宇**  亚略特CEO',
              ],
            },
            {
              time: '11:05-11:20',
              content: [
                '**《软通工业互联数字化工厂实践》**',
                '**李向前**  软通动力数字化创新服务线高级副总裁',
              ],
            },
            {
              time: '11:20-11:30',
              content: [
                '**【发布仪式】基于OpenHaromony软硬融合元宇宙平台2.0发布**',
                '**雒冬梅**  软通动力技术研究院副院长',
              ],
            },
            {
              time: '11:30-11:45',
              content: [
                '**《软通动力DataSwap工具，助力企业快速应用openGauss》**',
                '**田可辉**  软通动力计算生态业务项目经理',
              ],
            },
            {
              time: '11:45-12:00',
              content: [
                '**《基于国产开源操作系统的智能化工厂改造实践》**',
                '**陆志刚**  诚迈科技鸿志事业部高级技术总监',
              ],
            },
          ],
          guest: '演讲嘉宾（拟邀）',
          peopleImage: 'https://res.oafimg.cn/-/1fef4ceda1af2481/output.jpg',
          producerCounts: 0,
        },
        {
          time: '14:00-17:20',
          title: '开源EDA分论坛',
          content: '开源EDA分论坛将向业界分享国内头部院所及企业在数字设计、模拟设计、芯片制造、芯片封装、处理器设计自动化等五大领域的实践经验；联合规划o-Test、xSynth、ICPD、openBase、openPDK、openSDAPD、openPCB、TedHun、openPDA核心技术框架进展，以及金光SPICE助力高职教育工作等内容。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '14:00-14:15',
              content: [
                '**领导致辞**',
              ],
            },
            {
              time: '14:15-14:30',
              content: [
                '**开源机制探索---产学研联合规划共性技术框架**',
                '**何均宏**  openDACS工委会联合主任&执行总监',
              ],
            },
            {
              time: '14:30-14:50',
              content: [
                '**开源芯片生态发展态势与趋势**',
                '**包云岗**  openDACS战略合作委员会 联合主任、中科院计算所副所长',
              ],
            },
            {
              time: '14:50-15:10',
              content: [
                '**构建从电路到系统的开源EDA工具链**',
                '**李华伟**  openDACS工委会主任、中科院计算所研究员、全国重点实验室副主任',
              ],
            },
            {
              time: '15:10-15:20',
              content: [
                '**oVerify：设计验证的开源价值与开源框架规划**',
                '**黄武**  芯华章 产品市场战略总监',
              ],
            },
            {
              time: '15:20-15:35',
              content: [
                '**xSynth：逻辑综合（多目标驱动）开源框架与合作**',
                '**罗国杰**  工委会委员 北京大学长聘副教授',
                '**王宇成**  鸿芯微纳CTO',
              ],
            },
            {
              time: '15:35-15:50',
              content: [
                '**ICPD：物理设计及建模验证开源框架与合作**',
                '**杨帆**  工委会委员 复旦大学教授',
                '**（待定）**  上海伴芯 CTO',
              ],
            },
            {
              time: '15:50-16:05',
              content: [
                '**开源EDA工具链集成和流片验证**',
                '**解壁伟**  工委会委员 中科院计算所 助理研究员',
              ],
            },
            {
              time: '16:05-16:20',
              content: [
                '**openPDK: 先进器件模型与PDK开源框架与合作**',
                '**李志强**  工委会委员 中科院微电子所研究员',
                '**王宗源**  华大九天 高级技术经理',
              ],
            },
            {
              time: '16:20-16:35',
              content: [
                '**openSDAPD&openPCB: 仿真驱动的先进封装与PCB设计开源框架**',
                '**徐宁**  工委会委员 武汉理工大学教授',
                '**苏周祥**  芯和半导体 技术支持总监苏周祥',
              ],
            },
            {
              time: '16:35-16:50',
              content: [
                '**Tedhub：模拟开源芯片设计平台框架与合作**',
                '**叶佐昌**  工委会委员 清华大学副教授',
              ],
            },
            {
              time: '16:50-17:05',
              content: [
                '**openPDA：处理器设计自动化框架与合作**',
                '**王颖**  工委会委员 中科院计算所副研究员',
                '**许荣峰**  奇普乐CEO',
              ],
            },
            {
              time: '17:05-17:20',
              content: [
                '**Open GoldenLight SPICE：助力高职集成电路人才培养**',
                '**余菲**  深圳职业技术学院电子与通信工程学院副院长',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/c3034b3cf7e3ea41/output.jpg',
          producerCounts: 1,
        },
      ],
    },

    {
      divide: '分会场3',
      day: 'DAY 1',
      report: '会议室DE',
      content: [
        {
          time: '10:30-12:50',
          title: '绿色基础设施技术分论坛',
          content: '在国家碳达峰碳中和整体政策的指引下，蚂蚁在 2021 年也公布碳中和路线图，而在公布碳中和路线图之前，蚂蚁的数据中心已经开始打造并采用各种绿色计算相关的技术来实现数据中心的节能减排，数据中心的绿色计算牵扯到数据中心软件的各个方面，除了调度相关的系统之外，在分布式系统软件，风控场景下的图计算，运维的效率以及容器的弹性方面，也和绿色计算息息相关。本次论坛邀请了蚂蚁集团各个领域的专家，和大家分享在各个领域在绿色计算方面的一些实践经验，和大家一起探讨绿色计算的未来的发展趋势，欢迎大家一起交流。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '10:30-10:40',
              content: [
                '**开场+致辞**',
              ],
            },
            {
              time: '10:40-11:05',
              content: [
                '**开源分布式事务框架 Seata 及其在金融场景的实践**',
                '**李玉明**  蚂蚁集团高级技术专家，数据中间件负责人',
              ],
            },
            {
              time: '11:05-11:30',
              content: [
                '**TuGraph Analytics 流图计算:数据智能新引擎**',
                '**潘臻轩**  蚂蚁集团资深技术专家',
              ],
            },
            {
              time: '11:30-11:55',
              content: [
                '**开源平台工程技术栈 KusionStack 及在蚂蚁的规模化实践**',
                '**何子波**  蚂蚁集团高级技术专家',
              ],
            },
            {
              time: '11:55-12:20',
              content: [
                '**云原生弹性安全容器NanoVisor**',
                '**谈鉴锋**  蚂蚁集团操作系统研发经理',
              ],
            },
            {
              time: '12:20-12:50',
              content: [
                '**圆桌：可信基础设施技术的新机遇 or 伪命题？**',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/5e0de9a892a7b5e9/output.jpg',
          producerCounts: 1,
        },
        {
          time: '14:00-17:15',
          title: '科学智能专场分论坛',
          content: '深度学习与科学模型的有机结合，给传统的科学领域带来了新的发展机遇，也正在推动科研范式的创新。如何高效地用AI助力科学研究？需要什么基础设施？又将怎样与产业落地结合？敬请关注科学智能专场分论坛！',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '14：00~14：05',
              content: [
                '**开场**',
              ],
            },
            {
              time: '14:05~14:15',
              content: [
                '**开场致辞**',
                '**李建欣**  北京航空航天大学',
              ],
            },
            {
              time: '14：15~14：45',
              content: [
                '**AI科学计算业界趋势及MindSpore实践**',
                '**倪宁曦** 华为昇思MindSpore架构师',
              ],
            },
            {
              time: '14：45~15：15',
              content: [
                '**AI for Mathematics**',
                '**董彬**  北京大学，北京国际数学研究中心长聘教授、国际机器学习研究中心副主任',
              ],
            },
            {
              time: '15：15~15：45',
              content: [
                '**当AI遇上量子计算**',
                '**徐旭升**  昇思MindSpore Quantum研究员',
              ],
            },
            {
              time: '15：45~16：15',
              content: [
                '**基于计算共形几何的网格生成**',
                '**郑晓朋**  大连理工大学软件学院副教授',
              ],
            },
            {
              time: '16：15~16：45',
              content: [
                '**Why Julia? AI 科学计算的挑战**',
                '**陈久宁**  同元科学计算高级专家',
              ],
            },
            {
              time: '16：45~17：15',
              content: [
                '**AI加持下的云端IDE-人工智能百倍人类的10个编码场景**',
                '**徐磊**  英捷创软首席架构师，SmartIDE开源项目创始人，微软最有价值专家',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/ceac4f88a8650615/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场4',
      day: 'DAY 1',
      report: '信创园：经开区国家信创园会议中心9号楼一层会场',
      content: [
        {
          time: '14:00-17:50',
          title: '开源法律与合规分论坛',
          content: '随着开源在推动创新、促进协作方面的作用日益凸显，开源领域的法律与合规问题日益受到关注。本论坛将汇聚全球开源领域法律与合规专家，共同从理论和实践维度，就开放创新模式下知识产权纠纷的最新案例、开源相关的合规管理与维权实务、以及与AI相关的前沿法律问题等进行深度、细致的全方位探讨。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '14:00-14:20',
              content: [
                '**领导致辞**',
              ],
            },
            {
              time: '14:20-14:30',
              content: [
                '**嘉宾/专家致谢**',
                '**开源法律手册发布**',
              ],
            },
            {
              time: '14:30-14:50',
              content: [
                '**开放创新模式下知识产权新类型法律纠纷**',
                '**张 平**  北京大学法学院教授',
              ],
            },
            {
              time: '14:50-15:10',
              content: [
                '**开源项目的合规管理**',
                '**沈 芬**  华为开源法律专家',
              ],
            },
            {
              time: '15:10-15:30',
              content: [
                '**以代理律师视角解读全国首例GPL抗辩获得支持案**',
                '**李维朝**  江苏瑞途律师事务所合伙人',
              ],
            },
            {
              time: '15:30-15:50 ',
              content: [
                '**涉开源软件的维权策略与抗辩应对**',
                '**周丹丹**  北京市集佳律师事务所合伙人',
              ],
            },
            {
              time: '15:50-16:10',
              content: [
                '**人工智能与开源：法律的新兴领域**',
                '**Heather Meeker**  Tech Law Partners, LLP 合伙人、OSS资本合伙人',
              ],
            },
            {
              time: '16:10-16:30',
              content: [
                '**开源域外司法实践及其借鉴**',
                '**欧轩琦**  工业和信息化部电子第五研究所开源团队研究员、CCF《开源战略动态》期刊编委',
              ],
            },
            {
              time: '16:30-17:00',
              content: [
                '**人工智能：跨境时的法律与版权问题及开放许可下的语言模型发展**',
                '**Andrew Katz**  Moorcrofts LLP合伙人',
              ],
            },
            {
              time: '17:00-17:50',
              content: [
                '**圆桌讨论：开源合规实务交流、开源AI相关法律问题讨论**',
                '**李欣博(圆桌主持人)**  京东集团知识产权顾问',
                '**胡灵灵**  蚂蚁集团高级法务专家',
                '**孙振华**  字节跳动知识产权法务专家',
                '**王东芳**  Ladas & Parry中国首席代表',
                '**王红燕**  中伦律师事务所合伙人',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/a0a637fe6261a271/output.jpg',
          producerCounts: 1,
        },
      ],
    },
  ],
}
